/*
 * @Author: zyy
 * @Date: 2023-09-06 14:47:41
 * @LastEditTime: 2023-09-06 14:49:16
 * @FilePath: /tjzhsq-admin/src/io/vip/exp.js
 * @Description: 经验值
 * 
 */
import Axios from 'axios';
import Qs from 'qs';

export default {
    list(params) {
        return Axios.get('/community/api/admin/growth/integral/list', {
            params,
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    edit(params) {
        return Axios.post(`/community/api/admin/growth/integral/update/${params.id}`, params)
    },
    setStatus(params) {
        return Axios.post(`/community/api/admin/growth/integral/setStatus/${params.id}`, params)
    }


}